module.exports = __webpack_public_path__ + "img/class_education.8b24c6f6.jpg";